var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgShowPwDefault = function SvgShowPwDefault(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    "aria-hidden": true,
    viewBox: "0 0 16 11",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.014 2.226c-.25.028-.64.084-.89.14.11.194.194.556.222.75 0 .863-.723 1.559-1.558 1.559-.223 0-.585-.084-.751-.195-.084.25-.14.612-.14.863a3.11 3.11 0 0 0 3.117 3.116 3.11 3.11 0 0 0 3.116-3.116 3.13 3.13 0 0 0-3.116-3.117m7.903 2.727C14.414 2.003 11.409 0 8.014 0 4.59 0 1.586 2.003.084 4.953a1.02 1.02 0 0 0 0 .807c1.502 2.95 4.507 4.925 7.93 4.925 3.395 0 6.4-1.975 7.903-4.925a1.02 1.02 0 0 0 0-.807M8.014 9.35c-2.755 0-5.287-1.53-6.623-4.007C2.727 2.866 5.26 1.336 8.014 1.336c2.727 0 5.259 1.53 6.595 4.007C13.273 7.819 10.74 9.35 8.014 9.35"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShowPwDefault);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;